export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjY0NTA3MThmLWEwZDUtNDAzMi1iNTcxLTU5ZDJmMmQyZWE3MyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQyCn0=.ey4nJZCw7rdtPTg/BonPSDQfDGouN2bIFHtxTb8Q1sAKzaOEqFOy5CAKwkFGq5twMuAsWGCn+P1sS3L3H32pwRm2xc7itRTivxZbRQWzlAp46SUuHc0ku0PH69IcjwFIkiGvHA==';
